import { Box, Typography } from "@mui/material";
import * as React from "react";

type PageTitleProps = React.PropsWithChildren<{
  variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  component?: React.ElementType;
}>;

function PageTitle({ children, variant, component }: PageTitleProps) {
  return (
    <Box
      sx={{
        backgroundColor: (t) => t.palette.primary.main,
        color: (t) => t.palette.getContrastText(t.palette.primary.main),
        minHeight: {
          xs: 48,
          md: 72,
          lg: 96,
          xl: 120,
        },
        py: {
          xs: 1,
          md: 2,
          lg: 5,
        },
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        flexWrap: "wrap",
      }}
    >
      <Typography variant={variant || "h1"} component={component || "h1"}>{children}</Typography>
    </Box>
  );
}

export { PageTitle };
